import React, { useState, useEffect } from "react";
import { useStepperContext } from "../StepperContext";
import axios from "axios";
import AWS from "aws-sdk";
import { useSelector, useDispatch } from "react-redux";
import {
  addCitizenship,
  addCitizenshipError,
  addCity,
  addCityError,
  addCountry,
  addCountryError,
  addDob,
  addDobError,
  addEmail,
  addExperienceError,
  addExperienceYearError,
  addFName,
  addFirstnameError,
  addFreelanceEmailError,
  addFreelancePhoneError,
  addGithubURLError,
  addHourlyrateError,
  addInterestDescription,
  addJobLookFor,
  addJobtypeError,
  addLName,
  addLastnameError,
  addLinkedinURLError,
  addMonthlysalaryError,
  addPHourRate,
  addPJobExp,
  addPJobInt,
  addPMonthlySalary,
  addPNum,
  addPriJobInterestError,
  addProffExp,
  addResume,
  addSkills,
} from "@/lib/redux/Features/freelancerSlice";
import { useRouter } from "next/navigation";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactLoading from "react-loading";

function Final() {
  const [shouldNavigate, setShouldNavigate] = useState(false);
  //loading usestate (both s3 upload & api hit)
  const [loading, setLoading] = useState(false);
  const [loadingFile, setLoadingFile] = useState(false);
  const [interestDescriptionError,setInterestDescriptionError]=useState("")

  let { userData, setUserData } = useStepperContext();
  const interestDescription = useSelector(
    (state) => state.freelancer.interestDescription,
  );
  const resume = useSelector((state) => state.freelancer.resume);
  const [file, setFile] = useState(null);
  const router = useRouter();
  const dispatch = useDispatch();
  const maxLength = 250;

  useEffect(() => {
    if (shouldNavigate) {
      router.push("/");
    }
  }, [shouldNavigate,router]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "interestDescription") {
      const inputValue = e.target.value;
      if (inputValue.length <= maxLength) {
        setUserData({ ...userData, [name]: inputValue });
        dispatch(addInterestDescription(inputValue));
      }
    } else {
      const file = e.target.files[0];
      const fileName = file.name;
      setUserData({ ...userData, [name]: fileName });
      setFile(file);
      dispatch(addResume("yes"));
    }

    if (name === "interestDescription") {
      if (value.trim() === "") {
        setInterestDescriptionError("interest Description is required");
      } else {
        setInterestDescriptionError("");
      }
    }
  };


  const currentDateTime = new Date();
  // Convert to UTC
  const utcDateTime = new Date(
    currentDateTime.getUTCFullYear(),
    currentDateTime.getUTCMonth(),
    currentDateTime.getUTCDate(),
    currentDateTime.getUTCHours(),
    currentDateTime.getUTCMinutes(),
    currentDateTime.getUTCSeconds()
  );
  
  // IST is UTC + 5:30
  const IST_OFFSET = 5.5 * 60 * 60 * 1000; // 5 hours and 30 minutes in milliseconds
  const istDateTime = new Date(utcDateTime.getTime() + IST_OFFSET);
  
  // Extract date and time in IST
  const date = istDateTime.toISOString().split('T')[0]; // Extract date part
  const time = istDateTime.toTimeString().split(' ')[0]; // Extract time part (HH:MM:SS)

  // Add date and time to userData
  userData = { ...userData, date, time };
  console.log(userData);

  const onSubmit = async () => {
    setLoading(true);
    setLoadingFile(true);
  

    try {
      const response = await axios.post(
        "https://czbn4co62k.execute-api.ap-south-1.amazonaws.com/prod/freelance",
        userData,
      );
      if (response) {
        dispatch(addFName(null));
        dispatch(addLName(null));
        dispatch(addPNum(null));
        dispatch(addEmail(null));
        dispatch(addDob(null));
        dispatch(addCountry(null));
        dispatch(addCity(null));
        dispatch(addCitizenship(null));
        dispatch(addJobLookFor(null));
        dispatch(addProffExp(null));
        dispatch(addPJobInt(null));
        dispatch(addPJobExp(null));
        dispatch(addSkills(null));
        dispatch(addPHourRate(null));
        dispatch(addPMonthlySalary(null));
        dispatch(addInterestDescription(null));
        dispatch(addResume(null));
        dispatch(addFreelanceEmailError(null));
        dispatch(addFreelancePhoneError(null));
        dispatch(addFirstnameError(null));
        dispatch(addLastnameError(null));
        dispatch(addCitizenshipError(null));
        dispatch(addCountryError(null));
        dispatch(addDobError(null));
        dispatch(addCityError(null));
        dispatch(addExperienceError(null));
        dispatch(addJobtypeError(null));
        dispatch(addPriJobInterestError(null));
        dispatch(addExperienceYearError(null));
        dispatch(addHourlyrateError(null));
        dispatch(addMonthlysalaryError(null));
        dispatch(addLinkedinURLError(null));
        dispatch(addGithubURLError(null));

        setUserData({});
        setLoading(false);
      }

      const S3_BUCKET = "freelancerresume";
      const REGION = "ap-south-1";

      AWS.config.update({
        accessKeyId: "AKIARUPBEGTUPWNQZPGN",
        secretAccessKey: "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",
      });
      const s3 = new AWS.S3({
        params: { Bucket: S3_BUCKET },
        region: REGION,
      });

      const params = {
        Bucket: S3_BUCKET,
        Key: file.name,
        Body: file,
      };

      var upload = s3
        .putObject(params)
        .on("httpUploadProgress", (evt) => {
          // console.log(
          //   "Uploading " + parseInt((evt.loaded * 100) / evt.total) + "%",
          // );
          null
        })
        .promise();

      await upload.then((err, data) => {
        
        setLoadingFile(false);
      alert("File uploaded successfully.");
      });
      
    } catch (error) {
      alert(error);
    }
    toast("We will get back to you with opportunities");
    setTimeout(() => {
      setShouldNavigate(true);
    }, 3000);
  };

  const remainingCharacters = maxLength - (userData["interestDescription"] ? userData["interestDescription"].length : 0);
const result = remainingCharacters > 0 ? remainingCharacters : maxLength;
  

  return (
    <>
      <div className="flex flex-col ">
        <div className="mx-2 flex-1">
          <div className="mt-3 h-auto text-xs font-bold uppercase leading-8 text-gray-500 mb-3">
            What type of projects would you like to work on?*
          </div>

          <textarea
            value={userData["interestDescription"] || ""}
            onChange={handleChange}
            name="interestDescription"
            placeholder="Project interest(max 250 characters)"
            rows={5} // Adjust the number of rows as needed
            maxLength={maxLength}
            style={{ resize: "none" }} // Disable textarea resizing
            className="resize-none w-full max-w-lg border rounded p-2"
          />
          <div>
          
          {result} characters
            remaining
          </div>
          {interestDescriptionError && <span className="text-red-500">{interestDescriptionError}</span>}
        </div>
        <div className="mx-2 flex-1">
          <div className="mt-3 h-6 text-xs font-bold uppercase leading-8 text-gray-500 mb-3">
            Upload Resume*
          </div>
          <input type="file" name="resume" onChange={handleChange} />
        </div>
        <div className="mx-2 flex-1 flex justify-center items-center mt-6">
  <button
    onClick={onSubmit}
    className={`rounded-lg py-2 px-4 font-semibold uppercase text-white transition duration-200 ease-in-out mt-10 ${
      !interestDescription || !resume || loading || loadingFile ? "bg-gray-400 cursor-not-allowed" : "bg-green-500 hover:bg-slate-700 hover:text-white cursor-pointer"
    }`}
    disabled={!interestDescription || !resume || loading || loadingFile}
  >
    Confirm
  </button>

  {(loading || loadingFile) && (
    <ReactLoading
      type={"bubbles"}
      color={"black"}
      height={"20%"}
      width={"20%"}
    />
  )}
</div>

      </div>
      <ToastContainer />
    </>
  );
}

export default Final;
